import React from "react";
import {
  BookOpen,
  Music,
  Book,
  BookMarked,
  X,
  Feather,
  MessageCircle,
  Mic,
  Headphones,
  FileText,
  Sparkles,
  Film,
} from "lucide-react";

const ContentTypeSelector = ({ postType, setPostType }) => {
  // Updated: Changed "Poem" to "Poetry", "Stories" to "Story", added "Script"
  const allCategories = [
    { type: "Poetry", icon: Feather },
    { type: "Shayari", icon: Sparkles },
    { type: "Ghazal", icon: BookOpen },
    { type: "Song", icon: Music },
    { type: "Rap", icon: Mic },
    { type: "Hip-Hop", icon: Headphones },
    { type: "Novel", icon: Book },
    { type: "Story", icon: BookMarked }, 
    { type: "Book", icon: FileText },
    { type: "Script", icon: Film }, 
    { type: "Quote", icon: MessageCircle },
  ];

  // Find the currently selected type
  const selectedType = allCategories.find((ct) => ct.type === postType);

  // If a post type is selected, show the minimal selected badge
  if (postType && selectedType) {
    const Icon = selectedType.icon;
    return (
      <div className="mt-4 sm:mt-0 mb-6 sm:mb-8">
        <div className="flex flex-col sm:flex-row sm:items-center px-4 sm:px-0 gap-2 sm:gap-3">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-gray-900 border border-gray-800 rounded-full text-white shadow-sm w-fit">
            <Icon size={16} className="sm:w-4 sm:h-4" />
            <span className="text-sm font-medium">{selectedType.type}</span>
            <button
              type="button"
              onClick={() => setPostType("")}
              className="ml-1 p-1 hover:bg-gray-800 rounded-full transition-colors"
              aria-label="Change content type"
            >
              <X size={14} className="sm:w-3 sm:h-3" />
            </button>
          </div>
          <span className="text-xs text-gray-500 px-1">
            Click × to change content type
          </span>
        </div>
      </div>
    );
  }

  // Category selector with pill-style layout
  return (
    <div className="mb-6 px-4 md:px-8 lg:px-12">
      {/* Header Section */}
      <div className="mb-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-black mb-2">
          What would you like to share?
        </h2>
        <p className="text-sm md:text-base text-gray-600">
          Choose a content type for your post.
        </p>
      </div>

      {/* Categories - Centered with flex wrap */}
      <div className="flex flex-wrap gap-2 md:gap-3 justify-center">
        {allCategories.map(({ type, icon: Icon }) => (
          <button
            key={type}
            type="button"
            onClick={() => setPostType(type)}
            className="inline-flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-300 rounded-full hover:border-black hover:bg-gray-50 active:bg-gray-100 transition-all duration-200 shadow-sm hover:shadow"
          >
            <Icon
              size={18}
              className="text-black flex-shrink-0"
              strokeWidth={2}
            />
            <span className="text-sm font-medium text-black whitespace-nowrap">
              {type}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ContentTypeSelector;